import React from 'react';

const IconLogOut = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 1024 1024"
  >
    <path
      fill="rgb(74, 74, 74)"
      d="M493.474 655.159q-21.895 18.526 0 37.053 8.421 8.421 18.526 8.421t18.526-8.421l161.684-161.684q3.368-1.684 6.737-8.421 1.684-10.105 0-20.211-3.368-6.737-6.737-8.421l-161.684-161.684q-18.526-21.895-37.053 0-21.895 18.526 0 37.053l114.526 116.211h-581.053q-26.947 0-26.947 26.947t26.947 26.947h581.053zM997.053 53.896h-646.737q-26.947 0-26.947 26.947v215.579q0 26.947 26.947 26.947t26.947-26.947v-188.632h592.842v808.421h-592.842v-188.632q0-26.947-26.947-26.947t-26.947 26.947v215.579q0 26.947 26.947 26.947h646.737q26.947 0 26.947-26.947v-862.316q0-26.947-26.947-26.947z"
    />
  </svg>
);

export default IconLogOut;
